define(
// @formatter:off
    'partials/models/FormModel',[
        'jquery',
        'mmc.libs.log',
        'backbone'
    ],
    function(
        $,
        log,
        Backbone
    ) {
// @formatter:on
    var FormModel = Backbone.Model.extend({
        type: '',
        url : '',

        initialize : function(options) {
            this.type = options.type;
            this.url = options.url;
        },

        sendRequest : function($form, successCallback, errorCallback) {
            $form.ajaxSubmit({
                url : this.url,
                type : 'POST',
                dataType : 'json',
                data : {
                    campaign : ''
                },
                cache : false,
                uploadProgress : function (evt, position, total, percentComplete) {
                    $('#upload-progress').css('width', percentComplete + '%');
                    $('#uploadedMb').html((percentComplete * total / (100 * 1024 * 1024)).toFixed(2));
                    if (percentComplete === 100) {
                        $('#uploading').hide();
                        $('#uploaded').show();
                        $('#filename').attr('data-errormessage', 'Ihr File besitzt einen falschen Mime-Type, bitte verwenden Sie ein anderes File.');
                    }
                },
                success : function(data) {
                    if (data.success === true) {
                        $('#filename').attr('value', data.filename);
                        data.redirect = false;
                        if ($form.attr('id') === 'personal-data-form') {
                            data.redirect = true;
                        }
                        successCallback(data);
                    } else {
                        errorCallback(data.errorMsg);
                    }
                },
                error : errorCallback
            });
        }

    });

    return FormModel;
});

